export type LoginResponse = {
  status: string;
  name: string;
  orgId: string;
  isAgp: string;
  email: string;
  mobile: string;
  countryCode: string;
  id: string;
  usertype: string[];
  userId: string;
  roles: string[];
  accessibleScreens: unknown[];
  subscriptionExpiryDate: string;
  welcomeNotification: Record<string, string>;
  permissions: {
    appName: string;
    permissions: Permission[];
  };
  canDeactivateRestore: boolean;
  defaultOrgId: string;
  dashboardPages: string[];
  token: string;
  refreshToken: string;
};

type Permission = {
  moduleName: string;
  operations: Operation[];
};

type Operation = {
  create: boolean;
  read: boolean;
  update: boolean;
  delete: boolean;
};

export const getLoginResponse = (): LoginResponse | null => {
  const raw = localStorage.getItem("login-response");
  if (!raw) return null;

  try {
    const parsed: unknown = JSON.parse(raw);
    return parsed as LoginResponse;
  } catch {
    return null;
  }
};
